import { useState, useEffect } from "react";
import { Box } from "@mui/material";
import { useNavigate, useParams } from "react-router";
import { useFormik } from "formik";
import * as Yup from "yup";
import { request } from "../../config/request.ts";
import { toast } from "react-toastify";
import PageHeader from "../../shared/PageHeader/index.tsx";
import TextField from "../../shared/TextField/index.tsx";
import SelectField from "../../shared/SelectField/index.tsx";
import PageWrapper from "../../shared/PageWrapper/index.tsx";
import "../../styles/scss/Form.scss";

export default function MasterServiceCreateEdit() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [loading, setLoading] = useState(false);

  const formik = useFormik({
    initialValues: {
      serviceName: "",
      sortOrder: "",
      status: "Active",
    },
    validationSchema: Yup.object({
      serviceName: Yup.string().required("Service name is required"),
      sortOrder: Yup.string().required("Sort order is required"),
    }),
    onSubmit: async (values) => {
      const payload = {
        ...values,
        sortOrder: Number(values.sortOrder),
      };
      try {
        let response;
        if (id) {
          response = await request.put(
            "/api/updateMasterService/" + id,
            payload,
          );
        } else {
          response = await request.post("/api/createMasterService", payload);
        }

        if (response?.data?.status) {
          toast.success("Master service saved successfully!");
          navigate("/admin/master-services");
        }
      } catch (error) {
        toast.error(
          error?.response?.data?.message ||
            "An error occurred. Please try again.",
        );
      }
    },
  });

  useEffect(() => {
    if (id) {
      const fetchService = async () => {
        setLoading(true);
        try {
          const response = await request.get(`/api/getMasterServiceById/${id}`);
          const service = response.data.data;
          formik.setValues({
            serviceName: service.serviceName || "",
            sortOrder: service.sortOrder?.toString() || "",
            status: service.status === "Active" || service.status === true ? "Active" : "Inactive",
          });
          setLoading(false);
        } catch (error) {
          console.log(error);
          setLoading(false);
        }
      };

      fetchService();
    }
  }, [id]);

  return (
    <PageWrapper loading={loading}>
      <Box className="form-container">
        <Box className="form-page">
          <Box className="form-header">
            <PageHeader
              title={
                id && id !== "new"
                  ? "Edit Master Service"
                  : "Create New Master Service"
              }
              secondaryButton={{
                label: "Cancel",
                onClick: () => navigate("/admin/master-services"),
              }}
              primaryButton={{
                label: id && id !== "new" ? "Update Service" : "Create Service",
                icon: <span className="material-symbols-outlined">save</span>,
                onClick: () => formik.handleSubmit(),
              }}
            />
          </Box>

          <Box className="form-card">
            <Box className="form-card-body">
              <Box className="form-grid form-grid--2">
                <Box className="form-field">
                  <TextField
                    name="serviceName"
                    label="Service Name"
                    type="text"
                    formik={formik}
                    autoFocus
                  />
                </Box>
                <Box className="form-field">
                  <SelectField
                    name="status"
                    label="Status"
                    formik={formik}
                    options={[
                      { value: "Active", label: "Active" },
                      { value: "Inactive", label: "Inactive" },
                    ]}
                  />
                </Box>
                <Box className="form-field">
                  <TextField
                    name="sortOrder"
                    label="Sort Order"
                    type="number"
                    formik={formik}
                  />
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </PageWrapper>
  );
}
